import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({
  PRODUCT_STATUS_OBTAINED: 0, // 下架
  PRODUCT_STATUS_SHELF: 1, // 上架
  PRODUCT_MIN_BUY_SKU_COUNT: 1, //单sku最小购买数量
  PRODUCT_MAX_BUY_SKU_COUNT: 500, //单sku最大购买数量

  // 虚拟兑换门店类型
  ITEM_STORE_TYPE_IS_EXCHANGE: 1, // 兑换
  ITEM_STORE_TYPE_IS_DELIVERY: 2, // 配送
  ITEM_STORE_TYPE_IS_SELF_LIFTING: 3, // 自提

  // 下单前校验，订单类型
  ORDER_VERIFY_TYPE_NORMAL: 0, // 普通订单
  ORDER_VERIFY_TYPE_EXAMINE: 7, // 体检订单

  // 下单前校验，业务信息-业务类型
  ORDER_VERIFY_BUSNIESSINFO_TYPE_EXAMINE: 2, // 体检业务
  ORDER_VERIFY_BUSNIESSINFO_TYPE_COURSE: 5, // 在线课程业务
  // 现金券折扣
  COUPONS_DISCOUNTTYPE_MONEY_TYPE_FIXED: 0,
  COUPONS_DISCOUNTTYPE_MONEY_TYPE_RANDOM: 1,
  COUPONS_DISCOUNTTYPE_PRICE_TYPE_FIXED: 2,
  COUPONS_DISCOUNTTYPE_PRICE_TYPE_RANDOM: 3,
  // 现金券使用状态
  COUPONS_STATUS_UN_USED: 1,
  COUPONS_STATUS_USED: 2,
  // 推荐商品
  ITEM_COMMOND_PRODUCT: 1,
  ITEM_LOOK_PRODUCT: 2,

}, km({

  ITEM_GETTER_GET_LIST: null,

  ITEM_GET_LIST_START: null,
  ITEM_GET_LIST_SUCCESS: null,
  ITEM_GET_LIST_ERROR: null,
  ITEM_GET_LIST_ERROR_EMPTY: null,
  ITEM_GET_LIST_ERROR_TMR: null,

  ITEM_GET_DETAIL_START: null,
  ITEM_GET_DETAIL_SUCCESS: null,
  ITEM_GET_DETAIL_ERROR: null,
  ITEM_GET_DETAIL_ERROR_EMPTY: null,
  ITEM_GET_DETAIL_ERROR_TMR: null,
  ITEM_GET_DETAIL_NO_PRODUCT: null,

  ITEM_GET_DESC_START: null,
  ITEM_GET_DESC_SUCCESS: null,
  ITEM_GET_DESC_ERROR: null,
  ITEM_GET_DESC_ERROR_EMPTY: null,
  ITEM_GET_DESC_ERROR_TMR: null,

  ITEM_GET_ATTR_START: null,
  ITEM_GET_ATTR_SUCCESS: null,
  ITEM_GET_ATTR_ERROR: null,
  ITEM_GET_ATTR_ERROR_EMPTY: null,
  ITEM_GET_ATTR_ERROR_TMR: null,

  ITEM_MAGNIFY_SHOW: null,
  ITEM_MAGNIFY_HIDE: null,

  ITEM_SELECTED_SKU_STORE: null,
  ITEM_TO_ORDER_AFRER_LOGIN: null,
  ITEM_GETPRODUCTCITYLIST_SUCCESS: null,
  ITEM_GETPRODUCTCITYLIST_ERROR: null,
  ITEM_CHECKDELIVERY_SUCCESS: null,
  ITEM_CHECKDELIVERY_ERROR: null,
  ITEM_QUERYAREAINFOBYIDS_SUCCESS: null,
  ITEM_QUERYAREAINFOBYIDS_ERROR: null,


  ITEM_GET_PRODUCT_ATTRS_SUCCESS: null,
  ITEM_GET_PRODUCT_ATTRS_ERROR: null,

  ITEM_CHECKDELIVERY_SUCCESS: null,
  ITEM_CHECKDELIVERY_ERROR: null,
  ITEM_QUERYAREAINFOBYIDS_SUCCESS: null,
  ITEM_QUERYAREAINFOBYIDS_ERROR: null,
// 兑换商品的门店
  ITEM_GET_STORE_LIST_SUCCESS: null,
  ITEM_GET_STORE_LIST_ERROR: null,
  ITEM_GET_STORE_DETAIL_SUCCESS: null,
  ITEM_GET_STORE_DETAIL_ERROR: null,

  // 现金券
  ITEM_GET_SUITABLE_COUPON_SUCCESS: null,
  ITEM_GET_SUITABLE_COUPON_ERROR: null,
  ITEM_SET_SUITABLE_COUPON_SUCCESS: null,
  ITEM_SET_SUITABLE_COUPON_ERROR: null,

  // 推荐
  // 为您推荐商品
  ITEM_GET_RELATED_PRODUCT_SUCCESS: null,
  ITEM_GET_RELATED_PRODUCT_ERROR: null,

  // 看了又看商品
  ITEM_GET_LOOK_RELATED_PRODUCT_SUCCESS: null,
  ITEM_GET_LOOK_RELATED_PRODUCT_ERROR: null,

  /*yeoman-template-point-1*/
}))
